<template>
    <Transition name="modal">
      <div v-if="show" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <div>
                <img src="@/assets/logo-azul.png" id="icon" alt="User Icon" />
              </div>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>
  
            <div class="modal-footer">
            <button class="btn btn-primary" @click="$emit('close')">
              Cancelar
            </button>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="$emit('ok')">
              Aceptar
            </button>
          </div>
          </div>
        </div>
      </div>
    </Transition>
  </template>
  
  <script>
  export default {
    props: {
      show: Boolean,
    },
  };
  </script>
  
  <style>
  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;

}
.modal-header{
    display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.modal-body {
      display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
}

.modal-default-button {
  float: right;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center; 
  width: 100%;
}


.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
  </style>